<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>

          <!-- <template #cell(rowSelector)="row">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item)"
                class="mt-1 mr-1"
                title="Capitolato"
              >
                Capitolato
              </b-button>
            </div>
          </template> -->

          <template #cell(pdf)="row">
            <!-- <base-checkbox name="check" class="check" v-model="row.item.pdf" /> -->
            <base-checkbox name="check" class="check" v-model="row.item.pdf" />
          </template>

          <template #cell(csv)="row">
            <!-- <base-checkbox name="check" class="check" v-model="row.item.csv" /> -->
            <base-checkbox name="check" class="check" v-model="row.item.csv" />
          </template>

          <!-- <template #cell(customer)="{ item }" v-if="items.length">
            {{ item.attributables.SURN + " " + item.attributables.NAME }}
          </template> -->

          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>

          <!-- <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                  ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template> -->
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <b-row v-if="!noPagination">
        <div class="show-text">
          <p>Mostra</p>
        </div>
        <div class="group">
          <b-form-group
            label-for="per-page-select"
            label-cols-sm="3"
            label-cols-md=""
            label-cols-lg="3"
            label-size="sm"
            md="auto"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              style="width: 68px"
              size="sm"
              @change="onPageChange(1)"
              :disabled="!items.length"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="page">
          <p>di {{ totalItems }} per pagina</p>
        </div>
        <div class="pagination" v-if="totalItems">
          <b-pagination
            v-model="currentPage"
            limit="3"
            :total-rows="totalItems"
            :per-page="perPage"
            size="sm"
            @change="onPageChange"
          ></b-pagination>
        </div>
      </b-row>
      <!-- <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab> </button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal> -->
    </div>
  </div>
</template>

<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
// import Todo from "@/components/profile/brokers/salesmen/details/Todo";
// import Notes from "@/components/profile/brokers/salesmen/details/Notes";
// import Appointments from "@/components/profile/brokers/salesmen/details/Appointments";
// import General from "@/components/profile/brokers/salesmen/details/General";
// import ButtonGroupTab from "@/components/ButtonGroupTab";
import BaseCheckbox from "@/components/form/BaseCheckbox";

export default {
  name: "ReportsTable",
  extends: template,
  inject: ["args"],
  data() {
    return {
      // tabs: [
      //   { name: "General", text: "Generale" },
      //   { name: "Appointments", text: "Appuntamenti" },
      //   { name: "Notes", text: "Note" },
      //   { name: "Todo", text: "Attività" },
      // ],
      // selected: "General",
      modalResourceId: null,
      // tabIndex: 0,
      // args: null,
      tabs: [{ name: "None", text: "Nessuno" }],
      selected: "None",
      tabIndex: 0,
    };
  },
  components: {
    BaseIcon,
    // Appointments,
    // Notes,
    // Todo,
    // General,
    BaseCheckbox,
    // ButtonGroupTab,
  },
  methods: {
    // customized(item) {
    //   let c = {};
    //   c.nome = item.attributables.NAME;
    //   c.cognome = item.attributables.SURN;
    //   c.codice_fiscale = item.attributables.BUID;
    //   return c;
    // },
  },
  beforeMount() {
    // this.args = this.$parent.args;
  },
};
</script>
<style scoped>
td {
  margin: 0 !important;
}
</style>